module.exports = __webpack_public_path__ + "img/check_circle.8c114a4a.svg";